
// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;

			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.c-hamburger').length > 0) {
		$('.c-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is_open');
				nav.removeClass('is_close');
			} else {
				nav.removeClass('is_open');
				nav.addClass('is_close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.c-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is_open');
			nav.addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.c-hamburger:visible').length > 0) {
				$('.c-hamburger').click();
			}
		});
	}
});


// スクロールヒント
window.addEventListener('DOMContentLoaded', function () {
	new ScrollHint('.js-scrollable', {
		scrollHintIconAppendClass: 'scroll-hint-icon-white',
		i18n: {
			scrollable: "スクロールできます"
		}
	});
});


// ----- 店舗情報ページ
// 店舗画像のスライダー
const shopGallerySwipers = document.querySelectorAll(".p-shop__gallery .swiper");

shopGallerySwipers.forEach(function (shopGallerySwiper) {
	const shopGallery = new Swiper(shopGallerySwiper, {
		speed: 1000,
		loop: true,
		// loopAdditionalSlides: 1,    
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		slidesPerView: 1.2,
		centeredSlides: true,
		spaceBetween: 15,

		// ブレークポイント（画面幅による設定）
		breakpoints: {
			// 画面幅が 768px 以上の場合（window width >= 768px）
			768: {
				slidesPerView: 1.8,
				spaceBetween: 30,
			},
			// 画面幅が 1024px 以上の場合（window width >= 1024px）
			1024: {
				slidesPerView: 2.3,
				spaceBetween: 50,
			},
		},

		navigation: {
			nextEl: shopGallerySwiper.closest(".p-shop__gallery").querySelector(".swiper-button-next"),
			prevEl: shopGallerySwiper.closest(".p-shop__gallery").querySelector(".swiper-button-prev"),
		},
	});
});


// ----- ラインナップ詳細ページ
// ポイントのメインスライダー
const lineupPointMainSlides = document.querySelectorAll(".p-lineupPoint__main .swiper-slide");
const lineupPointMainElement = document.querySelector(".p-lineupPoint__main");

if (lineupPointMainElement) {
	if (lineupPointMainSlides.length >= 2) {
		const lineupPointMain = new Swiper(".p-lineupPoint__main .swiper", {
			speed: 1000,
			loop: true,
			// loopAdditionalSlides: 1,	
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			slidesPerView: 1,
			spaceBetween: 18,
			centeredSlides: true,

			navigation: {
				nextEl: ".p-lineupPoint__main .swiper-button-next",
				prevEl: ".p-lineupPoint__main .swiper-button-prev",
			},
		});
	} else {
		lineupPointMainElement.classList.add("is-noSlider");
	}
}

// ----- ラインナップ詳細ページ
// ポイントのサブスライダー
// 768px以上の時はスライドの数が5枚以上であればスライダー起動
// 768px以下の時はスライドの数が2枚以上であればスライダー起動
const lineupPointSubElement = document.querySelector(".p-lineupPoint__sub");

if (lineupPointSubElement) {

	const lineupPointSubSlides = lineupPointSubElement.querySelectorAll(".swiper-slide");
	let shouldInitSlider = false;
	let slidesToShow = 2;

	// 768px以上で、スライドが5枚以上だったら
	if (window.innerWidth >= 768) {
		if (lineupPointSubSlides.length >= 5) {
			shouldInitSlider = true;
			slidesToShow = 4;
		}
	}

	// 768px以下で、スライドが2枚以上だったら
	else {
		if (lineupPointSubSlides.length >= 2) {
			shouldInitSlider = true;
			slidesToShow = 1;
		}
	}

	if (shouldInitSlider) {
		const lineupPointSub = new Swiper(".p-lineupPoint__sub .swiper", {
			speed: 1000,
			loop: true,
			loopAdditionalSlides: 1,
			autoplay: {
				delay: 2400,
				disableOnInteraction: false,
			},
			slidesPerView: slidesToShow,
			centeredSlides: window.innerWidth >= 768, // 768px以上の場合のみ centeredSlides を true にする
			spaceBetween: window.innerWidth >= 768 ? 15 : 10, // ブレークポイントに合わせて spaceBetween を設定

			breakpoints: {
				768: {
					slidesPerView: 3,
					centeredSlides: true,
					spaceBetween: 15,
				},
				1024: {
					slidesPerView: 4,
					centeredSlides: false,
					spaceBetween: 20,
				},
			},

			navigation: {
				nextEl: ".p-lineupPoint__sub .swiper-button-next",
				prevEl: ".p-lineupPoint__sub .swiper-button-prev",
			},
		});
	} else {
		lineupPointSubElement.classList.add("is-noSlider");
	}
}



// ----- ラインナップ詳細ページ
// 共通設備スライダー
// 768px以上の時はスライドの数が5枚以上であればスライダー起動
// 768px以下の時はスライドの数が2枚以上であればスライダー起動
const lineupCommonSlides = document.querySelectorAll(".p-lineupCommon__subGallery");

lineupCommonSlides.forEach(function (gallery) {
	const slides = gallery.querySelectorAll(".p-lineupCommon__subGallery .swiper-slide");

	let shouldInitSlider = false;
	let slidesToShow = 2;

	// 768px以上で、スライドが5枚以上だったら
	if (window.innerWidth >= 768) {
		if (slides.length >= 5) {
			shouldInitSlider = true;
			slidesToShow = 4;
		}
	}
	// 768px以下で、スライドが2枚以上だったら
	else {
		if (slides.length >= 2) {
			shouldInitSlider = true;
			slidesToShow = 1;
		}
	}

	if (shouldInitSlider) {
		const lineupCommon = new Swiper(gallery.querySelector(".p-lineupCommon__subGallery .swiper"), {
			speed: 1000,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			slidesPerView: slidesToShow,
			spaceBetween: window.innerWidth >= 768 ? 15 : 10, // ブレークポイントに合わせて spaceBetween を設定
			centeredSlides: window.innerWidth >= 768, // 768px以上の場合のみ centeredSlides を true にする

			breakpoints: {
				768: {
					slidesPerView: 3,
					centeredSlides: true,
					spaceBetween: 15,
				},
				1024: {
					slidesPerView: 4,
					centeredSlides: false,
					spaceBetween: 20,
				},
			},

			navigation: {
				nextEl: gallery.querySelector(".swiper-button-next"),
				prevEl: gallery.querySelector(".swiper-button-prev"),
			},
		});
	} else {
		gallery.classList.add("is-noSlider");
	}
});


// ----- ラインナップ詳細ページ
// ラインナップ スペックモーダル
jQuery(document).ready(function ($) {

	// モーダルを表示
	$('.js-modalTrigger').on('click', function () {
		var modalIndex = $(this).data('modal-index');
		var modalSelector = '.c-modal[data-modal-index="' + modalIndex + '"]';

		// bodyにoverflow: hidden; を適用して背景スクロールを不可にする
		$('body').css('overflow', 'hidden');
		// 対応するモーダルが存在する場合のみ表示
		if ($(modalSelector).length > 0) {
			$(modalSelector).fadeIn();
		}
	});

	// 閉じるボタンをクリックしてモーダルを非表示
	$('.c-modal__close').on('click', function () {
		// モーダルを非表示
		$('.c-modal').fadeOut();

		// bodyのoverflowを元に戻す
		$('body').css('overflow', 'auto');
	});

	// 背景をクリックしてモーダルを非表示
	$('.c-modal').on('click', function (event) {
		var modalIndex = $(this).data('modal-index');
		var modalSelector = '.c-modal[data-modal-index="' + modalIndex + '"]';

		// モーダル内の要素をクリックした場合はモーダルを非表示にせずに終了
		if ($(event.target).hasClass('c-modal')) {
			// 対応するモーダルを非表示
			$(modalSelector).fadeOut();

			// bodyのoverflowを元に戻す
			$('body').css('overflow', 'auto');
		}
	});
});


// ----- 中古車詳細ページ
// 中古車画像のスライダー
// サムネイル
const carsSliderThumbnail = new Swiper(".p-cars__slideThum .swiper", {
	slidesPerView: 3, // サムネイルの枚数
	spaceBetween: 15,

	breakpoints: {
		768: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
	},
});

// スライダー
const carsSlider = new Swiper(".p-cars__slide .swiper", {
	loop: true,
	effect: "fade", // フェード
	// 前後の矢印
	navigation: {
		nextEl: ".p-cars__slideThum .swiper-button-next",
		prevEl: ".p-cars__slideThum .swiper-button-prev",
	},
	thumbs: {
		swiper: carsSliderThumbnail,
	},
});


// ベストショットページ
// モーダルウィンドウ
jQuery(function ($) {
	$('.js-modal-open').click(function () {
		$(this).parent('.js-modal-item').next('.js-modal-window').fadeIn().css('display', 'flex');
		$('body').css('overflow', 'hidden');
	});
	$('.js-modal-window').on('click', function () {
		$(this).fadeOut();
		$('body').css('overflow', 'auto');
	});
});